import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserGroupEntityInfo } from 'record-it-time-common/entity/entities/UserGroup/createUserGroupEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { UserGroup } from './userGroupTypes';
export const userGroupEntityInfo = createUserGroupEntityInfo<UserGroup>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});